import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import ReactTable from 'react-table';

import moment from 'moment';
import 'moment-duration-format';
import SelectTable from '../../../components/v3/CalibrationScreenV3/SelectTable';
import ExportToExcel from '../../../components/v3/utils/ExportToExcel';

import {
    updateProps,
    loadComcastLiveAgentSurveyScreen,
    loadLiveSurveys,
} from './ComcastLiveAgentSurveyScreenActions';
import { arrayIsNotEmpty, formatDateTime, getSelectedIndividualNode, pageLoaded } from '../../../utils';

class ComcastLiveAgentSurveyScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFilters: []
        };
        this._init = this._init.bind(this);

        this._init();
    }

    componentDidMount() {
        pageLoaded('Live Surveys');
        this.props.dispatch(loadComcastLiveAgentSurveyScreen());
    }

    _init() {
        const endDate = moment().format("MM/DD/YYYY");
        const startDate = moment().startOf('month').format("MM/DD/YYYY");
        this.props.dispatch(updateProps({ startDate: startDate, endDate: endDate }));
    }

    getSelectFilterPopup = () => {
        const
            {
                domainValues
            } = this.props;

        if (!arrayIsNotEmpty(domainValues))
            return;

        const domainObject = domainValues.find(f => f.domainId === this.state.filterIdToShow)
        const newArray = domainObject.domainValues.map(obj => {
            return {
                id: obj.domainValueId,
                name: obj.domainValueName,
                domainId: domainObject.domainId
            };
        });
        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select "
                    searchPlaceHolder="Search..."
                    options={newArray}
                    onClose={this.hideFilterPopup} />
            </div>
        </div>);
    }

    getSelectAgentPopup = () => {
        const
            {
                agentsOfTeamsOfTheUser
            } = this.props;

        if (!arrayIsNotEmpty(agentsOfTeamsOfTheUser))
            return;

        return (<div className="modal displayBlock" >
            <div className="modal-content modal-content-selectTeam">
                <SelectTable
                    selectMultiple={true}
                    title="Select "
                    searchPlaceHolder="Search..."
                    options={agentsOfTeamsOfTheUser}
                    onClose={this.hideAgentFilterPopup} />
            </div>
        </div>);
    }

    hideFilterPopup = (newFilters) => {
        this.setState({ showSelectFilterPopup: false });

        const filteredNewFilters = newFilters.filter(newFilter => {
            return !this.state.selectedFilters.some(selectedFilter => selectedFilter.id === newFilter.id);
        });

        this.setState(prevState => ({
            selectedFilters: [...prevState.selectedFilters, ...filteredNewFilters]
        }));
    }

    hideAgentFilterPopup = (newFilters) => {
        this.setState({ showSelectAgentPopup: false });

        const filteredNewFilters = newFilters.filter(newFilter => {
            return !this.state.selectedFilters.some(selectedFilter => selectedFilter.id === newFilter.id);
        });

        this.setState(prevState => ({
            selectedFilters: [...prevState.selectedFilters, ...filteredNewFilters]
        }));
    }

    removeFilter = (domainId) => {
        const updatedFilters = this.state.selectedFilters.filter(filter => filter.id !== domainId);

        this.setState({ selectedFilters: updatedFilters });
    }

    onApplyFilters = () => {
        this.props.dispatch(updateProps({
            liveSurveys: undefined,
        }));
        this.props.dispatch(loadLiveSurveys(this.state.selectedFilters));
    }

    getFilters = () => {
        const
            {
                domainValues
            } = this.props;
        if (!arrayIsNotEmpty(domainValues))
            return;

        const filters = domainValues.filter(a => a.domainName === 'Supervisor').map(f => <div key={f.domainId}
            className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0' }}
            onClick={() => this.setState({ showSelectFilterPopup: true, filterIdToShow: f.domainId })}>
            + {f.domainName}
        </div>);

        const agentFilterButton = <div key={999}
            className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0' }}
            onClick={() => this.setState({ showSelectAgentPopup: true })}>
            + Agent
        </div>

        const selectFilterPopup = this.state.showSelectFilterPopup ? this.getSelectFilterPopup() : undefined;
        const selectAgentPopup = this.state.showSelectAgentPopup ? this.getSelectAgentPopup() : undefined;

        const selectedFilters = this.state.selectedFilters.map(obj => getSelectedIndividualNode(domainValues, obj, this.removeFilter));

        const applyFilterButton = (
            <div className="v3-button" style={{ display: 'inline-flex', margin: '0 10px 2px 0', background: '#98DDE1' }} onClick={this.onApplyFilters}  >
                Apply Filter
            </div>);

        return (<>
            <div style={{ padding: '10px 0 0 10px' }} className="flex flex-space-between align-items-flex-start">
                <div>
                    {agentFilterButton}
                    {applyFilterButton}
                </div>
            </div>
            <div className="flex flex-space-between">
                <div style={{ display: 'inline-flex', flexWrap: 'wrap', alignItems: 'center', margin: '10px 0 10px 10px' }}>
                    {selectedFilters}
                    <div style={{ marginBottom: '1px' }}>
                        {selectFilterPopup}
                        {selectAgentPopup}
                    </div>

                </div>
            </div>
        </>);
    }

    render() {
        const
            {
                liveSurveys
            } = this.props;

        const filters = this.getFilters();

        let result = {};
        const idColumn =
        {
            Header: 'Id',
            accessor: 'surveyResultTempId'
        };

        const nameColumn = {
            Header: 'Name',
            accessor: 'name',
            width: 300
        };
        const teamColumn = {
            Header: 'Team',
            accessor: 'teamName',
            width: 200
        };
        const aniColumn = {
            Header: 'ANI',
            accessor: 'ani',
            width: 200
        };

        const npsColumn = {
            Header: 'tNPS',
            accessor: 'responseQuestion1',
            width: 150
        };

        const resColumn = {
            Header: 'CPR',
            accessor: 'responseQuestion2',
            width: 150
        };

        const rfcColumn = {
            Header: 'RFC',
            accessor: 'rfC',
            width: 300
        };
        const submissionDateColumn = {
            Header: 'Submission Time',
            accessor: 'submissionDatePhi',
            width: 300
        };

        result.columns = [idColumn, nameColumn, teamColumn, aniColumn, npsColumn, resColumn, rfcColumn, submissionDateColumn];

        if (arrayIsNotEmpty(liveSurveys)) {
            result.data = liveSurveys;
            return (<div style={{ margin: '20px' }}>
                <div className="flex-basic flex-space-between">
                    <div>
                        {filters}
                    </div>
                    <ExportToExcel data={liveSurveys} fileName={`LiveSurvey - ${formatDateTime(new Date())}`} />
                </div>
                <ReactTable
                    data={result.data}
                    columns={result.columns}
                    defaultPageSize={10}
                    className="-striped -highlight" />
            </div>);
        }
        else {
            return <div style={{ margin: '20px' }}>
                {filters}
                <ReactTable
                    data={[]}
                    columns={result.columns}
                    defaultPageSize={10}
                    className="-striped -highlight" />
            </div>
        }
    }
}

const select = state => ({ ...state.ComcastLiveAgentSurveyScreen });

export default connect(select)(ComcastLiveAgentSurveyScreen);